import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetReadyOffersSelector } from 'selectors/testTarget/offers/testTargetReadyOffersSelector';

const persistFiltersOnBrandSelector = createSelector(testTargetReadyOffersSelector, offers => offers.persistFiltersOnBrand || Empty.Object);

export { persistFiltersOnBrandSelector };
